import PropTypes from "prop-types";
import { Button as HeadlessButton } from "@headlessui/react";
import cn from "classnames";
// Styles
import styles from "./Button.module.scss";

const Button = ({
  children,
  disabled = false,
  block = false,
  type = "primary",
  htmlType = "button",
  className,
  ...restProps
}) => {
  return (
    <HeadlessButton
      className={cn(
        styles.button,
        {
          [styles.block]: block,
          [styles.outline]: type === "outline",
          [styles.toast]: type === "toast",
        },
        className
      )}
      disabled={disabled}
      type={htmlType}
      {...restProps}
    >
      {children}
    </HeadlessButton>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  type: PropTypes.oneOf(["primary", "outline", "toast"]),
  htmlType: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default Button;
